<template>
    <div class="wrapper">
        <div
            class="loader"
            :class="{
                transparency: uiStore.loaderOptions.transparency,
                'with-content': !!slots.default,
            }">
            <spark-logo-animated class="logo" />
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
import { useUIStore } from '@/stores/uiStore.ts';
import SparkLogoAnimated from '@/components/layout/SparkLogoAnimated.vue';
import { useSlots } from 'vue';

const uiStore = useUIStore();
const slots = useSlots();

</script>

<style lang="scss" scoped>
.wrapper {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: var(--neutral0);
    z-index: 9999;

    &.transparency {
        background-color: var(--neutral0Alpha);
        backdrop-filter: blur(3px);
    }

    .loader {
        position: absolute;
        text-align: center;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 20%;
        display: flex;
        flex-direction: column;
        gap: var(--largeSpacing);

        &.with-content {
            width: 15%;
        }

        @include responsive('sm') {
            width: 95%;
        }

        .logo {
            display: block;
            width: 50%;
            height: auto;
            margin: 0 auto;
        }
    }
}

@keyframes indeterminate_first {
    0% {
      left: -100%;
      width: 100%;
    }
    100% {
      left: 100%;
      width: 10%;
    }
  }
</style>
